import { getWeekendInfoByName } from "../weekends/weekendInfo";

let joinLink: string = "https://forms.gle/3JDRXtEufwVW8JRL6";

export function getJoinLink(weekendId) {
    return getWeekendInfoByName(weekendId,"joinLink");
}